<script setup>
import { computed } from 'vue'
const props = defineProps(['to', 'hash', 'href', 'disabled', 'processing', 'iconLeft', 'icon', 'iconRight', 'target', 'label', 'mega', 'type'])
</script>

<template>
	<router-link v-if="to" :class="['btn group']" :disabled :to>
		<div class="relative flex">
			<!-- Content -->
			<div :class="['content']">
				<i class="icon far fa-circle-notch fa-spin group animate-spin" v-if="processing"></i>
				<template v-else>
					<div class="icon mr-2" v-if="iconLeft">
						<i :class="iconLeft"></i>
					</div>

					<!-- Main Label with hover effect -->
					<div class="label-container">
						<div class="label-content">
							<label class="label-main"><slot /></label>
							<label class="label-hover" aria-hidden="true"><slot /></label>
						</div>
					</div>

					<!-- Main Icon -->
					<div class="icon" v-if="icon">
						<i :class="icon"></i>
					</div>

					<div class="icon ml-2" v-if="iconRight">
						<i :class="iconRight"></i>
					</div>
				</template>
			</div>
		</div>
	</router-link>
	<component v-else :is="href ? 'a' : 'button'" :class="['btn group', { mega: mega != null }, type]" :disabled="disabled" :target="href ? (target ?? '_blank') : null" :href>
		<div class="relative flex">
			<!-- Content -->
			<div :class="['content']">
				<i class="icon far fa-circle-notch fa-spin group animate-spin" v-if="processing"></i>
				<template v-else>
					<div class="icon mr-2" v-if="iconLeft">
						<i :class="iconLeft"></i>
					</div>

					<!-- Main Label with hover effect -->
					<div class="label-container">
						<div class="label-content">
							<label class="label-main"><slot /></label>
							<label class="label-hover" aria-hidden="true"><slot /></label>
						</div>
					</div>

					<!-- Main Icon -->
					<div class="icon" v-if="icon">
						<i :class="icon"></i>
					</div>

					<div class="icon ml-2" v-if="iconRight">
						<i :class="iconRight"></i>
					</div>
				</template>
			</div>
		</div>
	</component>
</template>

<style scoped>
@reference '../../../css/theme.css';

/* Global / Default */
.btn {
	@apply h-fit w-fit cursor-pointer overflow-hidden rounded-lg text-2xl;
}
.btn .content {
	@apply flex h-12 items-center justify-center px-6;
}
.btn .icon {
	@apply text-sm;
}
.btn.wide,
.btn.wide .content {
	@apply w-full;
}
.btn.solid {
	@apply bg-snk-blue-500 text-white;
}
.btn.solid.light {
	@apply bg-snk-light-500 text-snk-blue-600;
}
.btn.solid.swc {
	@apply border border-[#d48401] bg-linear-to-br from-[#fef950] to-[#834000] font-bold! text-black;
}
.btn.secondary {
	@apply border border-snk-blue-500 text-snk-blue-900;
}
.btn.secondary.light {
	@apply border border-snk-blue-500 text-snk-light-500;
}
.btn.thin {
	@apply rounded-md;
}
.btn.thin .content {
	@apply h-8 w-full;
}
label {
	@apply text-sm font-medium;
}

/* Label */
.label-container {
	@apply relative overflow-hidden pt-1 leading-tight;
}
.label-content {
	@apply flex flex-col transition-transform duration-300 ease-out;
}
.label-main,
.label-hover {
	@apply flex cursor-pointer items-center whitespace-nowrap;
}
.label-hover {
	@apply absolute top-full;
}
.btn:hover .label-content {
	@apply -translate-y-full;
}
</style>
